module.exports = __webpack_public_path__ + "img/19-full-lg.74c578a0.jpg";